import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL, baseURLNoApi } from '@/httpService/API';

const apiURL = `${baseURL}/grt-user-center-service`;
//查询列表播放进度
export const handleListProgress = (data) => {
    return hMacAjax.post(apiURL + '/user/chapter/v1/video-progress', data);
};
//保存上次播放目录
export const saveLastPlay = (data) => {
    return hMacAjax.post(apiURL + '/user/learn-business/v1/latest-playing', data);
};
//章节列表-公开
export const getOpenChapterList = (data) => {
    return hMacAjax.post(apiURL + '/open/business/chapter/list', data);
};

//章节列表
export const getChapterList = (data) => {
    return hMacAjax.post(apiURL + '/user/chapter/v1/list-version', data);
};
//获取同级章节列表
export const getSiblingChapterList = (data) => {
    return hMacAjax.post(apiURL + '/user/chapter/v1/list-sibling', data);
};

// 课程详情
export const getCourseDetail = (id, data) => {
    return hMacAjax.get(apiURL + `/open/business/v1/app/${id}`, data);
};

// 是否项目学员校验
export const project_check = (data) => {
    return hMacAjax.post(apiURL + '/user/learn-business/v1/project-check', data);
};

//课程学习人数
export const getStudentNum = (data) => {
    return hMacAjax.get(apiURL + '/open/business/v1/learn-num', data);
};
// 收藏接口
export const addCollect = (data) => {
    return hMacAjax.post(apiURL + '/user/favorite/add', data);
};
// 取消收藏接口
export const cancelCollect = (data) => {
    return hMacAjax.post(apiURL + '/user/favorite/cancel', data);
};

//去学习校验
export const courseCheck = (data) => {
    return hMacAjax.post(apiURL + '/user/learn-business/v1/check', data);
};
// 获取华为云会议token
export const getLiveToken = (data) => {
    return hMacAjax.get(apiURL + '/user/meeting/appauth', data);
};

// 播放器客户端时间检查
export const getDate_Check = (data) => {
    return hMacAjax.get(apiURL + '/user/learn-business/v1/date-check', data);
};

//学习进度
export const getProcess = (data) => {
    return hMacAjax.get(apiURL + '/user/score-summary/totalScore', data);
};

//成绩明细
export const getScoreDetail = (data) => {
    return hMacAjax.get(apiURL + '/user/score-summary/scoreDetail', data);
};

//成绩规则提示
export const getTipInfo = (data) => {
    return hMacAjax.get(apiURL + '/user/score-summary/scoreRule', data);
};

/**
 * 查询会议设置
 * @param businessId
 * @param flag  是否基本信息 0否 1是
 * @returns {*}
 */
export const getSeminarSetting = async (businessId, flag) => {
    return await hMacAjax.get(apiURL + `/user/meeting/config/${businessId}`, { flag: flag }, false);
};

//去学习校验(带错误返回)
export const courseCheckIncludeErr = async (business_id, template_id) => {
    return await hMacAjax.post(
        apiURL + '/user/learn-business/v1/check',
        {
            business_id: business_id,
            template_id: template_id
        },
        false
    );
};

// 获取华为云会议token(带错误返回)
export const getLiveTokenIncludeErr = async (username) => {
    return await hMacAjax.get(apiURL + '/user/meeting/appauth', { name: username }, false);
};

// ------------项目 start-------------------

//教学详情
export const getCompositeDetail = (data) => {
    return hMacAjax.get(apiURL + '/user/business/v1/composite', data);
};

//教学内容树
export const getPlanTree = (data) => {
    return hMacAjax.get(apiURL + '/user/plan-tree/v1', data);
};

//成绩
export const projectScoreDetail = (data) => {
    return hMacAjax.get(apiURL + '/user/score-summary/v2/projectScoreDetail', data);
};

//成绩规则
export const projectScoreRule = (data) => {
    return hMacAjax.get(apiURL + '/user/score-summary/projectScoreRule', data);
};

//证书
export const getCertificate = (data) => {
    return hMacAjax.get(apiURL + '/user/certificate/v1', data);
};

//证书Image
export const getCertificateImage = (id, data) => {
    return hMacAjax.get(baseURLNoApi + '/p/cert/api/getCertUrl/1', data);
};

/**
 *   查询业务公告分页查询
 *   GET /user/business/notice/v1/page
 *   接口ID：118070880
 *   接口地址：https://app.apifox.com/link/project/2747941/apis/api-118070880
 */
export const getNoticeList = async (data) => {
    console.log(data, 'data');
    // let data = {
    //     template_id: templateId,
    //     business_id: businessId,
    //     class_id: classId,
    //     page_num: pageNum,
    //     page_size: pageSize
    // };
    return await hMacAjax.get(apiURL + '/user/business/notice/v1/page', data);
};

/**
 *   查询业务公告详情
 *   GET /user/business/notice/v1/{id}
 *   接口ID：118070778
 *   接口地址：https://app.apifox.com/link/project/2747941/apis/api-118070778
 * @param noticeId  公告id
 * @param templateId
 * @param businessId
 * @return {Promise<*>}
 */
export const getNoticeDesc = async (noticeId, data) => {
    return await hMacAjax.get(apiURL + `/user/business/notice/v1/${noticeId}`, data, false);
};

export const getNoticeRead = async (params) => {
    let data = {
        ...params,
        notice_type: 0
    };
    return await hMacAjax.get(apiURL + '/user/business/notice/v1/read', data);
};
export const getMessageRead = async (id, template_id, business_id, notice_type) => {
    let data = {
        id: id,
        template_id: template_id,
        business_id: business_id,
        notice_type: notice_type
    };
    return await hMacAjax.get(apiURL + '/user/business/notice/v1/read', data, true);
};
// ------------项目 end-------------------

// ------------报名 start-------------------
/**
 * 获取报名配置
 *   GET /open/enroll/v1
 *   接口ID：132855741
 *   接口地址：https://app.apifox.com/link/project/2747941/apis/api-132855741
 * @param relation_business_id  关联业务ID
 * @param relation_template_id   关联模板ID
 * @return {Promise<*>}
 */
export const getSignUpConfig = async (relation_business_id, relation_template_id) => {
    let data = {
        relation_business_id: relation_business_id,
        relation_template_id: relation_template_id
    };
    return await hMacAjax.get(apiURL + '/open/enroll/v1', data, true);
};

/**
 * 获取报名详情
 *   GET /user/enroll/v1
 *   接口ID：133089020
 *   接口地址：https://app.apifox.com/link/project/2747941/apis/api-133089020
 * @param business_id  业务ID
 * @param template_id  模板ID
 * @param relation_business_id  报名业务ID
 * @param relation_template_id  报名模板ID
 * @return {Promise<*>}
 */
export const getSignUpDesc = async (business_id, template_id, relation_business_id, relation_template_id) => {
    let data = {
        business_id: business_id,
        template_id: template_id,
        relation_business_id: relation_business_id,
        relation_template_id: relation_template_id
    };
    return await hMacAjax.get(apiURL + '/user/enroll/v1', data, true);
};

/**
 * 报名提交
 *   POST /user/enroll/v1
 *   接口ID：133370325
 *   接口地址：https://app.apifox.com/link/project/2747941/apis/api-133370325
 * @param id  配置ID
 * @param relation_business_id  报名业务ID
 * @param relation_template_id  报名模板ID
 * @return {Promise<*>}
 */
export const uploadSignUpInfo = (id, relation_business_id, relation_template_id, completeMap) => {
    let data = {
        id: id,
        relation_business_id: relation_business_id,
        relation_template_id: relation_template_id,
        ...completeMap
    };
    return hMacAjax.post(apiURL + '/user/enroll/v1', data, true);
};

/**
 * 报名提交新
 *   POST /user/enroll/v2
 * @param id  配置ID
 * @param relation_business_id  报名业务ID
 * @param relation_template_id  报名模板ID
 * @return {Promise<*>}
 */
export const uploadSignUpInfoNew = (id, relation_business_id, relation_template_id, completeMap) => {
    let data = {
        id: id,
        relation_business_id: relation_business_id,
        relation_template_id: relation_template_id,
        ...completeMap
    };
    return hMacAjax.post(apiURL + '/user/enroll/v2', data, true);
};

// ------------报名 end-------------------

// 查询手机号+学员id
//章节列表-公开
export const getStudentInfoReq = (params) => {
    return hMacAjax.get(apiURL + '/user/student/v1/mobile', params);
};

/**
 * 获取报名详情新
 *   post /user/enroll/info/v2
 * @param business_id  业务ID
 * @param template_id  模板ID
 * @param relation_business_id  报名业务ID
 * @param relation_template_id  报名模板ID
 * @return {Promise<*>}
 */
export const getSignUpDescNew = async (business_id, template_id, relation_business_id, relation_template_id) => {
    let data = {
        business_id: business_id,
        template_id: template_id,
        relation_business_id: relation_business_id,
        relation_template_id: relation_template_id
    };
    return await hMacAjax.get(apiURL + '/user/enroll/v2', data, true);
};

/**
 * 获取大赛是否配置了其他赛道
 *   post /user/enroll/info/v2
 * @param business_id  业务ID
 * @param template_id  模板ID
 * @return {Promise<*>}
 */
export const getEnrollDetail = async (business_id, template_id) => {
    let data = {
        business_id: business_id,
        template_id: template_id
    };
    return await hMacAjax.get(apiURL + '/user/business/config/detail', data, true);
};

// 赛道 下拉
export const businessPlan = `${apiURL}/user/business/plan`;
// 赛道 下拉
export const enrollBusiness = `${apiURL}/user/enroll/business/v1`;

export const checkUserHasCert = ({ business_id, template_id }) => {
    return hMacAjax.get(apiURL + '/user/certificate/v1/check', { business_id, template_id }, true);
};
export const uploadImage = (certificate_id, value) => {
    return hMacAjax.post(apiURL + '/user/certificate/v1/picture/update', { certificate_id, ...value }, true);
};
export const updateCertImage = (certificate_id) => {
    return hMacAjax.get(apiURL + '/user/certificate/v1/update', { certificate_id }, true);
};

//获取当前教学活动下的学习条件数据
export const getActivitiesRequired = (activityId, data) => {
    return hMacAjax.get(apiURL + `/user/plan-tree/v1/activities/${activityId}/required`, data);
};
